import { Timestamp } from 'firebase/firestore';

export const COMPANY_TYPES = [
  'inventor',
  'startup',
  'pme',
  'eti',
  'large-account',
  'public',
] as const;
export type CompanyType = (typeof COMPANY_TYPES)[number];

export const EMPLOYEE_RANGES = [
  '1-10',
  '11-50',
  '51-200',
  '201-1000',
  '1001-5000',
  '5001-10000',
  '10000+',
] as const;
export type EmployeeRange = (typeof EMPLOYEE_RANGES)[number];

export interface Client {
  name: string;
  description?: string;
  logoURL?: string;
  website?: string;
  linkedinURL?: string;
  industry?: string;
  companyType?: CompanyType;
  employeeRange?: EmployeeRange;
  country?: string;
  city?: string;
  foundedYear?: number;
  parentCompany?: string;
  tags?: string[];
  /** Intercompany flag — AIS, AI, NodOn, etc. Triggers the internal hourly rate. */
  isInternal?: boolean;
  /** Set by admin to soft-archive; null/absent = active. */
  archivedAt?: Timestamp | null;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}
